/*
 * One-time cleanup: an earlier version of the ship-date feature maintained
 * a cart.attributes.quoted_ship_date value via a background script. That
 * script has been removed (Flow now computes the ship date from order line
 * items instead), but any cart that already had this attribute set keeps
 * carrying it forever, since nothing else clears it — Shopify carries cart
 * attributes over as order note attributes regardless of whether anything
 * still maintains them. Left in place, this becomes a confusing, no-longer-
 * meaningful "quoted_ship_date" note attribute on future orders from that
 * cart, alongside the correct order metafield Flow computes from line
 * items. This script clears it out. It's self-limiting: once a cart's copy
 * is cleared, nothing sets it again, so this becomes a no-op for that cart
 * on every subsequent page load.
 */
(function () {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (response) { return response.json(); })
    .then(function (cart) {
      if (!cart.attributes || !cart.attributes.quoted_ship_date) return;

      var formData = new FormData();
      formData.append('attributes[quoted_ship_date]', '');

      return fetch(window.routes.cart_update_url, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
      });
    })
    .catch(function (error) {
      console.error('Error clearing stale quoted_ship_date cart attribute:', error);
    });
})();
